import { useState } from "react";
import NFTOverlay from "./NFTOverlay";
import Thumbnail from "./Thumbnail";
import UnloadedTokens from "./UnloadedTokens";
import equiv from "./util/equiv.js";
import defined from "./util/defined";
import useNFTCollection from "./hooks/useNFTCollection";

export default function Grid({ collection, tokenIDs, balance, loadMore }) {
    const [activeTokenID, setActiveTokenID] = useState();//'rgba(64, 32, 128,0.25)'
    const type = collection.symbol();
    const borderColor = type == 'MYSKELE' ? 'rgba(255, 170, 0, 0.25)'
        : type == 'SKEYS' ? 'rgba(255, 255, 0, 0.25)'
            : type == 'SKELE' ? 'rgba(3, 255, 0, 0.25)'
                : 'black';
    const closeOverlay = () => {
        setActiveTokenID(null);
    }
    return (<>
        {!!activeTokenID && <NFTOverlay closeFunction={closeOverlay} collection={collection} tokenID={activeTokenID} />}
        {defined(tokenIDs) ? < div className="grid" style={{ border: `2px solid ${borderColor}`, boxSizing: 'content-box' }} >
            {tokenIDs.map(tokenID => <Thumbnail onClick={setActiveTokenID} active={equiv(activeTokenID, tokenID)} key={`grid-${tokenID}`} collection={collection} tokenID={tokenID} />)}
            {tokenIDs.length < balance && <UnloadedTokens clickHandler={loadMore} quantity={balance - tokenIDs?.length} />}
        </div > : equiv(balance, 0) ? '' : <img src="/images/spinner.gif" />
        }
    </>)
}